<div *ngIf="selectable" [class]="{'fwd-roll-locktype':true, 'fwd-roll-locked':locked}">
  <i
    [class]="{icon:true, 'icon_ion_lock_filled':locked, 'icon-lock_open':!locked}"
    style="cursor: pointer"
    (mousedown)="onMouseDown($event)"
  ></i>
  <span class="badge-icon bfx-badge-info-bold" *ngIf="forwardFirstOrder">FF</span>
</div>
